import { X } from 'phosphor-react'
import { Badge, Button, Modal, Table } from 'react-bootstrap'

import styles from './styles.module.css'

function ModalTable({
  title,
  headers,
  data,
  show,
  onHide,
  loadMoreData,
  buttonText,
  missingDataText,
}) {
  return (
    <Modal centered size="lg" show={show} onHide={onHide}>
      <Modal.Header>
        {title}
        <Button className={styles.closeeBtn} onClick={onHide}>
          <X color="white" weight="bold" size={18} />
        </Button>
      </Modal.Header>
      {(data?.length ?? 0) > 0 ? (
        <>
          <Modal.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  {headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row)?.map((rowColumn, index) => (
                      <td key={index}>{rowColumn}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: 'center' }}>
            <Button className={styles.loadMoreBtn} onClick={loadMoreData}>
              {buttonText}
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <Modal.Body>
          <Badge bg="" className={styles.infoBadge}>
            {missingDataText}
          </Badge>
        </Modal.Body>
      )}
    </Modal>
  )
}

export default ModalTable
